import type { TOC } from '@ember/component/template-only';
import { concat, fn } from '@ember/helper';
import {
  PrismButton,
  PrismInput,
  PrismMessage,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import type ChangeEmailController from 'frontend-login/controllers/change-email';
import { LoginCard } from 'password-form';

import styles from './change-email.module.css';

interface ChangeEmailSignature {
  controller: ChangeEmailController;
}

<template>
  {{pageTitle (t "login.change_email")}}

  {{#if @controller.showSuccessScreen}}
    <LoginCard>
      <PrismMessage
        @description={{t
          "login.email_updated_description"
          email=@controller.newEmail
        }}
        @illustration="100x100_success"
        @title={{t "login.email_updated_title"}}
        class="mt-400"
      >
        <:primaryAction>
          <PrismButton
            @buttonType="primary"
            @label={{t "login.sign_in"}}
            @onClick={{fn @controller.redirectToLogin false}}
          />
        </:primaryAction>
      </PrismMessage>
    </LoginCard>
  {{else}}
    <LoginCard @title={{t "login.confirm_new_email"}}>
      <div class="mt-200 flex flex-col">
        <PrismInput
          @disabled={{true}}
          @label={{t "login.email"}}
          @name="email"
          @removePadding={{true}}
          @type="email"
          @value={{@controller.newEmail}}
          data-test-id="input-email"
        />
      </div>

      <div class="mt-400 flex justify-around gap-200">
        <PrismButton
          @buttonType="secondary"
          @label={{t "login.deny"}}
          @onClick={{fn @controller.redirectToLogin false}}
          class="w-1/2"
          data-test-id="button-deny-sso"
        />
        <PrismButton
          @label={{t "login.confirm_email"}}
          @onClick={{@controller.confirmEmailChange}}
          class="w-1/2"
        />
      </div>

      <p class={{concat "text-200--regular mt-400" " " styles.feedback}}>
        {{t
          "login.change_email_footer"
          class="prism-link prism-link--secondary"
          htmlSafe=true
        }}
      </p>
    </LoginCard>
  {{/if}}
</template> satisfies TOC<ChangeEmailSignature>;
